import React, { forwardRef, useRef, useMemo, useImperativeHandle, useEffect, useState } from "react";
import { Model, Serializer, RendererFactory, ItemValue, QuestionTextModel } from "survey-core";
import { Survey, SurveyQuestionDropdown, ReactQuestionFactory, } from "survey-react-ui";
import Select, { components } from 'react-select';
import Creatable, { useCreatable } from "react-select/creatable";
import { APIGet } from '../../API/APIRequest';
import { useParams } from 'react-router-dom'
import "survey-core/survey-core.min.css";
import "./resetSurvey.scss"
import { ReactComponent as MyCustomIcon } from '../Icons/down-arrow-black.svg'; // Import SVG

Serializer.addProperty("dropdown", { name: "adOtherValue:string" });
Serializer.addProperty("dropdown", { name: "dataEndpoint:string" });
Serializer.addProperty("radiogroup", { name: "adOtherValue:string" });
Serializer.addProperty("checkbox", { name: "adOtherValue:string" });
["text", "comment", "date", "datetime", "dropdown"].forEach(type => {
    Serializer.addProperty(type, { name: "answerCode:string" });
});


Serializer.addProperty("dropdown", {
    name: "addItem",
    type: "boolean",
    onSetValue: (surveyElement, value) => {
        surveyElement.setPropertyValue("addItem", value);
        if (value) {

            surveyElement.renderAs = "dropdown-react";
        } else {
            surveyElement.renderAs = "default";
        }
    },

}
);

class CustomSelect extends SurveyQuestionDropdown {
    constructor(props) {
        super(props);
    }
    get options() {
        return this.question.visibleChoices.map((c) => {
            return { value: c.value, label: c.value };
        });
    }
    get selectedOption() {
        return this.options.filter((o) => o.value == this.question.value);
    }
    onSelectChange = (selectedOption) => {
        const value = selectedOption ? selectedOption.value : null;
        this.setValueCore(value);
    };
    onCreateOption = (inputValue) => {
        if (!inputValue.trim()) return;

        // Check if value already exists
        const exists = this.question.choices.some(
            (choice) => choice.value === inputValue
        );
        if (!exists) {
            this.question.choices.push(
                new ItemValue({ value: inputValue, text: inputValue })
            );
        }

        this.setValueCore(inputValue);
    };
     loadOptions = (inputValue) => {
        return new Promise((resolve) => {
            const filteredOptions = this.options.filter((option) =>
                option.label.toLowerCase().includes(inputValue.toLowerCase())
            );
            resolve(filteredOptions);
        });
    };
    renderElement() {
        if (this.isDisplayMode) {

            return (
                <div
                    id={this.question.inputId}
                    className={this.question.getControlClass()}
                    disabled
                >
                    {this.question.displayValue || this.question.placeholder}
                </div>
            );
        }
        const noInlineStyles = {
            control: (provided, state) => ({
                ...provided,
                // Override to remove or neutralize styles
                backgroundColor: "inherit",
            }),
            menu: (provided) => ({
                ...provided,
                // Remove unwanted styles
                //boxShadow: "none"
            }),
            input: (provided) => ({
                ...provided,
                fontSize: "unset"
            }),
            placeholder: (provided) => ({
                ...provided,
                fontSize: "unset"
            })
            // Add additional component overrides as needed.
        };
        const createText = this.question.getPropertyValue("createText") || <span>Add new </span>;
        const CustomDropdownIndicator = (props) => {
            return (
                <components.DropdownIndicator {...props}>
                    <MyCustomIcon />
                </components.DropdownIndicator>
            );
        };
        return (
            <Creatable
                isClearable
                isSearchable
                components={{
                    DropdownIndicator: CustomDropdownIndicator
                }}
                className="customDropdown"
                id={this.question.inputId}
                value={this.selectedOption}
                onChange={this.onSelectChange}
                onCreateOption={this.onCreateOption}
                options={this.options}
                required={this.question.isRequired}
                menuPortalTarget={document.body}
                classNamePrefix="addItemdropdown"
                placeholder={this.question?.placeholder || "Search"}
                styles={noInlineStyles}
                formatCreateLabel={(inputValue) => <span class="addItemFormat"> {createText} <strong> {inputValue}</strong></span>}
                isValidNewOption={() => true} // Always show "Create" option
                //menuIsOpen={true}  

            />
        );
    }
}

// Register the CustomSelect component as a renderer under a custom name "sv-dropdown-react"
ReactQuestionFactory.Instance.registerQuestion("sv-dropdown-react", (props) => {
    return React.createElement(CustomSelect, props);
});

// Register "sv-dropdown-react" as a renderer for questions whose `type` is "dropdown" and `renderAs` property is "dropdown-react"
RendererFactory.Instance.registerRenderer(
    "dropdown",
    "dropdown-react",
    "sv-dropdown-react"
);


const SurveyForm = forwardRef(({ surveyCode } , ref) => {
    const [surveyData, setSurveyData] = useState(null);
    const [isHandling, setIsHandling] = useState(false);
    const { environment } = useParams();
 
    const handleonRender = (sender, options) => {
        if (options.question?.jsonObj?.isCountry) {
            if (options.question?.dataEndpoint) {
                handleendpoints(options)

            }
        }
        if (options.question?.addItem) { 
            if (options.question?.dataEndpoint) {
                handleendpoints(options)
        
            }
        }
        
        if (options.question.jsonObj?.searchable) {
            if (options.question.jsonObj?.dataEndpoint) {
                handleendpoints(options)
            }
        }
    
        let required = options.question.jsonObj?.isRequired;
        let surveyElement = options.htmlElement.querySelector("input, textarea");

        if (surveyElement) {
            surveyElement.addEventListener("blur", function (event) {
                const { value } = event.target;
                setTimeout(() => {
                    if (!value) {
                        options.question.hasErrors(true);
                    }
                }, 0);
            });
            if (!required) {
                options.htmlElement.childNodes[0].innerHTML += `<div class="optional">Optional</span>`;
            }
            if (options.question.getType() !== "checkbox" && options.question.getType() !== "radiogroup") return;
            let category = options.question.jsonObj?.choices;
            let categoryMap = {};

            // Map choices to their respective categories
            category?.forEach((choice) => {
                let category = choice.category || "";
                if (!categoryMap[category]) {
                    categoryMap[category] = [];
                }
                categoryMap[category].push(choice.value);
            });

            // Loop through each input (checkbox or radio button)
            let inputElements = options.htmlElement.querySelectorAll("input[type='radio'], input[type='checkbox']");
            // let OtherElements = options.htmlElement.querySelector("");

            inputElements.forEach((inputElement) => {
                let itemValue = inputElement.value;
                let itemParent = inputElement.closest('.sd-item'); // Use closest to get the parent question container
                let instertBeforeItem = inputElement.closest('.sd-question__content');
                let categoryList = Object.keys(categoryMap).find((key) =>
                    categoryMap[key].includes(itemValue)
                );


                if (categoryList) {

                    let groupContainer = options.htmlElement.querySelector(`.category-group-${categoryList.replace(/\s+/g, "-")}`);

                    if (!groupContainer) {
                        // Create the category group container if it doesn't exist
                        groupContainer = document.createElement("div");
                        groupContainer.className = `item-container category-group category-group-${categoryList.replace(/\s+/g, "-")}`;
                        groupContainer.innerHTML = ` <h5 class="module-subheading">${categoryList}</h5>`;
                        options.htmlElement.insertBefore(groupContainer, instertBeforeItem);
                    }

                    // Move the entire parent element of the radio/checkbox into the correct category group
                    if (itemParent) {
                        groupContainer.appendChild(itemParent);
                    }
                }
            })
        }

        }
  
    const handleValueChanged = (sender, options) => {
        if (isHandling) return;
        setIsHandling(true)
        if (options.name.endsWith("-Comment") 
         //   && (question.getType() === "dropdown" || question.getType() === "radiogroup" || question.getType() === "checkbox")
        )
        {
            const originalField = options.name.replace("-Comment", ""); 
            const question = sender.getQuestionByName(originalField);

            if (question.value === "other") {
                sender.setValue(originalField, question.adOtherValue || question.value);
            }
            else if (Array.isArray(question.value)) {
                if (question.value.includes("other") && !question.value.includes(question.adOtherValue))
                    question.value = [...question.value, question.adOtherValue];
                else if (!question.value.includes("other") && question.value.includes(question.adOtherValue))
                    question.value = question.value.filter(val => val !== question.adOtherValue);
            }
        }
        setIsHandling(false)
    };

    const handleendpoints = (options) => {
        APIGet({
            "controller": "account",
            "action": options.question.dataEndpoint,
            "identifier": surveyCode,
            "environment": environment
        })
            .then(function (response) {

                let data = response.data.choices;
                let choices = data.map(item => ({
                    value: item.name,
                    text: item.name
                }));
                options.question.choices = choices;

            })
    }
 

    useEffect(() => {
        const InlineForms = async () => {
            await APIGet({
                "controller": "account",
                "action": "getformbyid",
                "identifier": surveyCode,
                "environment": environment
            })
                .then(function (response) {
                    let survey = response.data.surveyData;
                    const surveyModel = new Model(survey);
                    //surveyModel.onValueChanging.add(handleValueChanging);
                    surveyModel.onValueChanged.add(handleValueChanged);
                    //surveyModel.onLoadChoicesFromServer.add(handleLoadChoicesFromServer); 
                    surveyModel.onOpenDropdownMenu.add((sender, options) => {
                        options.menuType = "dropdown"; // Options: "dropdown", "popup", "overlay"
                    });
                    surveyModel.onAfterRenderQuestion.add(handleonRender);
                    setSurveyData(surveyModel);
                
                });

        };

        InlineForms();
    }, []);

    //const surveyModel = useRef(new Model(surveyJson)); // SurveyJS model initialization
    //const surveyModel = useRef(new Model(surveyData)); // SurveyJS model initialization
 
  
    
    useImperativeHandle(ref, () => ({
        validateSurvey: () => surveyData.validate(),
        getSurveyData: () => surveyData.data,
        prefixAnswers: () => {
            const survey = surveyData;
            const questions = survey.getAllQuestions();

            questions.forEach(q => {
                if (q.name.startsWith("answercode_")) {
                    q.page.removeQuestion(q);
                }
            });

            questions.forEach((q) => {
                if (!q.isVisible) return;
                if (
                    ["text", "comment", "date", "datetime", "dropdown"].includes(q.getType()) &&
                    q.value &&
                    q.answerCode
                ) {
                    if (q.answerCode && q.value && ["string", "number"].includes(typeof q.value)) {
                        const page = q.page;
                        const hiddenQuestion = new QuestionTextModel("answercode_" + q.name);
                        hiddenQuestion.defaultValue = q.answerCode || "";
                        hiddenQuestion.visible = false;

                        page.addQuestion(hiddenQuestion);
                        survey.setValue(hiddenQuestion.name, hiddenQuestion.defaultValue);
                    }
                    /*const prefix = q.answerCode;

                    if (prefix && q.value && typeof q.value === "string") {
                        q.value = `${prefix}_ad|_${q.value}`;
                    }*/
                }
            });

            console.log("Prefixed values:", survey.data);
        }
    }));
    
    return surveyData ? <Survey model={surveyData} /> : <p>Loading survey...</p>;
});

export default SurveyForm;
